import PropTypes from "prop-types";
import styled from "styled-components";

const TagContainer = styled.div`
  width: fit-content;
  height: fit-content;
  border-radius: 25px;
  padding: 4px 10px;
  font-size: 8px;
  font-weight: 400;
  margin-left: 7px;
  line-height: 100%;
  align-self: center;
  background-color: #048af5;
  color: ${({ theme }) => theme.button.font.primary};
  font-size: 13px;
`;

export const Tag = ({ label = "New" }) => {
  return <TagContainer>{label}</TagContainer>;
};

Tag.propTypes = {
  label: PropTypes.string,
};
